module.exports = __webpack_public_path__ + "static/img/partner-logo16.66f969a9.png";